import { Button } from '@diversioteam/diversio-ds'
import React, { useState } from 'react'

import { Stage } from './../context/LumiContext.types'
import { useLumi } from './../hooks/useLumi'
import { AcceptedFile } from './AcceptedFile'
import { EmptyList } from './EmptyList'
import * as S from './queue.styles'

export const Queue = () => {
    const { acceptedFiles, onChangeStage } = useLumi()
    const [isProcessing, setIsProcessing] = useState(false)

    return (
        <S.QueueWrapper>
            <S.Title>Queue</S.Title>

            {acceptedFiles.length === 0 && <EmptyList />}

            {acceptedFiles.length > 0 && (
                <>
                    <S.List>
                        {acceptedFiles.map((acceptedFile) => (
                            <AcceptedFile
                                key={acceptedFile.path}
                                acceptedFile={acceptedFile}
                                onChangeProcessing={(value) => setIsProcessing(value)}
                            />
                        ))}
                    </S.List>

                    <Button color="primary" onClick={() => onChangeStage(Stage.Processing)} disabled={isProcessing}>
                        Transform Job Ads
                    </Button>

                    <S.Description>Lumi™ can make mistakes. Check important info.</S.Description>
                </>
            )}
        </S.QueueWrapper>
    )
}
